module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('loading', {
    attrs: {
      "position": "absolute",
      "text": "loading"
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }), _vm._v(" "), (!_vm.$route.meta.router2) ? _c('view-box', {
    ref: "viewBox",
    attrs: {
      "body-padding-bottom": _vm.bodyPaddBtm
    }
  }, [_c('router-view')], 1) : _vm._e(), _vm._v(" "), (_vm.$route.meta.router2) ? _c('router-view', {
    attrs: {
      "id": "vux_view_box_body"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBackTop),
      expression: "isBackTop"
    }],
    staticClass: "backTop",
    on: {
      "click": function($event) {
        _vm.toBackTop(0)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-fanhuidingbu"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated bounceInUp",
      "leave-active-class": "animated bounceOutDown "
    }
  }, [_c('login', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }]
  })], 1), _vm._v(" "), _c('toast', {
    attrs: {
      "type": _vm.toast.type,
      "position": _vm.toast.position,
      "is-show-mask": true,
      "width": _vm.toast.width,
      "text": _vm.toast.text
    },
    model: {
      value: (_vm.toast.show),
      callback: function($$v) {
        _vm.$set(_vm.toast, "show", $$v)
      },
      expression: "toast.show"
    }
  }), _vm._v(" "), _c('m-footer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isTab),
      expression: "isTab"
    }]
  }), _vm._v(" "), _c('animate-add-shop')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78816777"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 586
// module chunks = 0